import { render, staticRenderFns } from "./AdvertisingFilter.vue?vue&type=template&id=2f8542ea&scoped=true"
import script from "./AdvertisingFilter.vue?vue&type=script&lang=js"
export * from "./AdvertisingFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8542ea",
  null
  
)

export default component.exports